/// <reference path="../../_ext/Bases/TransDialog.ts" />
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class ProductionDialog extends _Ext.MFGTransDialog<ProductionRow, any> {
        protected getFormKey() { return ProductionForm.formKey; }
        protected getIdProperty() { return ProductionRow.idProperty; }
        protected getLocalTextPrefix() { return ProductionRow.localTextPrefix; }
        protected getNameProperty() { return ProductionRow.nameProperty; }
        protected getService() { return ProductionService.baseUrl; }
        protected getDeletePermission() { return ProductionRow.deletePermission; }
        protected getInsertPermission() { return ProductionRow.insertPermission; }
        protected getUpdatePermission() { return ProductionRow.updatePermission; }

        public form = new ProductionForm(this.idPrefix);
        
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 290;
            q.initMFGItemEditor(this, this.form.ItemDetails, Config);
         
        } 
    }
}